export default __webpack_public_path__ + "static/logo-e7afc631be0e2d1d9565a0f9b01fa80a.png";